module.exports = __webpack_public_path__ + "img/title-1-f452e1.png";